module.exports = __webpack_public_path__ + "img/car_sendai07.eff28049.jpg";